export const bazaryab_adminRoute = [
    {
        name: "bazaryab_admin",
        url: "/bazaryab-admin",
        template: '<div ui-view></div>',
    },
    {
        url: '/menu',
        name: 'bazaryab_admin.menu',
        component: 'bazaryabAdminMenu'
    },
    {
        url: '/vendors',
        name: 'bazaryab_admin.vendors',
        component: 'bazaryabAdminVendors'
    },
    {
        url: '/comments',
        name: 'bazaryab_admin.comments',
        component: 'bazaryabAdminComments'
    },
    {
        url: '/reports',
        name: 'bazaryab_admin.reports',
        component: 'bazaryabAdminReports'
    },
    {
        url: '/reports/:orderId',
        name: 'bazaryab_admin.reportDetail',
        component: 'bazaryabAdminReportDetail'
    },
    {
        url: '/Discount',
        name: 'bazaryab_admin.discounts',
        template: '<div ui-view></div>'
    },
    {
        url: '/List',
        name: 'bazaryab_admin.discounts.list',
        component: 'bazaryabAdminDiscountList'
    },
    {
        url: '/Create',
        name: 'bazaryab_admin.discounts.create',
        component: 'bazaryabAdminDiscountCreate'
    },
    {
        url: '/Edit/:id',
        name: 'bazaryab_admin.discounts.edit',
        component: 'bazaryabAdminDiscountEdit'
    },
    {
        url: '/approve',
        name: 'bazaryab_admin.approve',
        abstract: true,
        template: '<div ui-view></div>',
    },
    {
        url: '/category',
        name: 'bazaryab_admin.approve.category',
        component: 'bazaryabAdminApproveCategory'
    },
    {
        url: '/category/edit/:id',
        name: 'bazaryab_admin.editCategory',
        component: 'bazaryabAdminEditCategory'
    },
    {
        url: '/productType',
        name: 'bazaryab_admin.approve.productType',
        component: 'bazaryabAdminApproveProductType'
    },
    {
        url: '/productType/edit/:id',
        name: 'bazaryab_admin.editProductType',
        component: 'bazaryabAdminEditProductType'
    },
    {
        url: '/product',
        name: 'bazaryab_admin.approve.product',
        component: 'bazaryabAdminApproveProduct'
    },
    {
        url: '/manufacturer',
        name: 'bazaryab_admin.approve.manufacturer',
        component: 'bazaryabAdminApproveManufacturer'
    },
    {
        url: '/manufacturer/edit/:id',
        name: 'bazaryab_admin.editManufacturer',
        component: 'bazaryabAdminEditManufacturer'
    },
    {
        url: '/warranty',
        name: 'bazaryab_admin.approve.warranty',
        component: 'bazaryabAdminApproveWarranty'
    },
    {
        url: '/warranty/edit/:vendorId/:id',
        name: 'bazaryab_admin.editWarranty',
        component: 'bazaryabAdminEditWarranty'
    },
    {
        url: '/slideshow',
        name: 'bazaryab_admin.slideshow',
        component: 'bazaryabAdminSlideshow'
    },
    {
        url: '/edit/:id',
        name: 'bazaryab_admin.slideshow.edit',
        component: 'bazaryabAdminSlideshowEdit'
    },
    {
        url: '/create',
        name: 'bazaryab_admin.slideshow.create',
        component: 'bazaryabAdminSlideshowCreate'
    },
    {
        url: '/list',
        name: 'bazaryab_admin.slideshow.list',
        component: 'bazaryabAdminSlideshowList'
    },
];




// WEBPACK FOOTER //
// ./src/store-modules/app/route/bazaryab-admin/bazaryab-admin.ts